/* Delivery promise v5.5 — portal-backed parcel/pallet promise override.
   Cache bust: 2026-06-07a.
*/
(function () {
  if (window.__deliveryPromiseInit) return;
  window.__deliveryPromiseInit = true;

  var FR_HOLIDAYS = new Set([
    '2025-01-01','2025-04-21','2025-05-01','2025-05-08','2025-05-29',
    '2025-06-09','2025-07-14','2025-08-15','2025-11-01','2025-11-11','2025-12-25',
    '2026-01-01','2026-04-06','2026-05-01','2026-05-08','2026-05-14',
    '2026-05-25','2026-07-14','2026-08-15','2026-11-01','2026-11-11','2026-12-25',
  ]);

  (function loadFrHolidays() {
    var TTL_MS = 30 * 24 * 60 * 60 * 1000;
    var years = [new Date().getFullYear(), new Date().getFullYear() + 1];
    function cacheGet(year) {
      try {
        var raw = localStorage.getItem('frHolidays:' + year);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.ts || !parsed.dates) return null;
        if (Date.now() - parsed.ts > TTL_MS) return null;
        return parsed.dates;
      } catch (e) { return null; }
    }
    function cachePut(year, dates) {
      try { localStorage.setItem('frHolidays:' + year, JSON.stringify({ ts: Date.now(), dates: dates })); } catch (e) {}
    }
    function applyDates(dates) { dates.forEach(function (d) { FR_HOLIDAYS.add(d); }); }
    var changed = false;
    var pending = [];
    years.forEach(function (y) {
      var cached = cacheGet(y);
      if (cached) { applyDates(cached); changed = true; return; }
      pending.push(
        fetch('https://calendrier.api.gouv.fr/jours-feries/metropole/' + y + '.json')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (obj) { if (!obj || typeof obj !== 'object') return; var dates = Object.keys(obj); applyDates(dates); cachePut(y, dates); changed = true; })
          .catch(function () {})
      );
    });
    if (pending.length) {
      Promise.all(pending).then(function () { if (changed && typeof window.__deliveryPromiseRerender === 'function') window.__deliveryPromiseRerender(); });
    } else if (changed && typeof window.__deliveryPromiseRerender === 'function') {
      window.__deliveryPromiseRerender();
    }
  })();

  function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0'); }
  function isBusinessDay(d) {
    var dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    if (FR_HOLIDAYS.has(ymd(d))) return false;
    return true;
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getTime()); var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isBusinessDay(d)) added++; }
    return d;
  }
  function nextBusinessDay(start) {
    var d = new Date(start.getTime()); d.setDate(d.getDate() + 1);
    while (!isBusinessDay(d)) d.setDate(d.getDate() + 1);
    return d;
  }
  function frDate(d) { return d.toLocaleDateString('fr-FR', { weekday:'short', day:'numeric', month:'long' }); }
  function calendarDaysBetween(a, b) {
    var aMid = new Date(a.getFullYear(), a.getMonth(), a.getDate());
    var bMid = new Date(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.round((bMid - aMid) / 86400000);
  }
  function frDateRel(target, now) {
    var diff = calendarDaysBetween(now, target);
    if (diff <= 0) return "aujourd’hui";
    if (diff === 1) return "demain, " + target.toLocaleDateString('fr-FR', { day:'numeric', month:'long' });
    return target.toLocaleDateString('fr-FR', { weekday:'long', day:'numeric', month:'long' });
  }
  function parseCutoff(str) {
    var m = String(str || '12:00').match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return { h: 12, m: 0 };
    return { h: parseInt(m[1],10), m: parseInt(m[2],10) };
  }
  function parseFrDept(zip, country) {
    if (!zip || (country && country !== 'FR')) return null;
    var z = String(zip).trim();
    if (/^20[0-1]\d{2}$/.test(z)) return '2A';
    if (/^20[2-6]\d{2}$/.test(z)) return '2B';
    if (/^97[1-8]\d{2}$/.test(z)) return z.slice(0,3);
    if (/^98[6-8]\d{2}$/.test(z)) return z.slice(0,3);
    var m = z.match(/^(\d{2})\d{3}$/);
    if (m) return m[1];
    return null;
  }
  function loadJsonScript(root, role) {
    var tag = root.querySelector('script[data-role="' + role + '"]');
    if (!tag) return null;
    var raw = tag.textContent.trim();
    if (!raw || raw === 'null') return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }
  function lookupTransit(table, dept, country) {
    if (country === 'FR' || dept) {
      var deptMap = table.transit_by_dept || {};
      if (dept != null && deptMap[dept] != null) return deptMap[dept];
      if (deptMap['default'] != null) return deptMap['default'];
    }
    var ctryMap = table.transit_by_country || {};
    if (country && ctryMap[country] != null) return ctryMap[country];
    return ctryMap['default'] != null ? ctryMap['default'] : 5;
  }
  function getCurrentVariantId(root) {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])');
    if (input && input.value) return input.value;
    try { var u = new URL(window.location.href); var v = u.searchParams.get('variant'); if (v) return v; } catch (e) {}
    return root.dataset.initialVariantId || null;
  }
  function getRequestedQuantity() {
    var qtyInput = document.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"], .product-form__quantity .quantity__input');
    return qtyInput ? parseInt(qtyInput.value, 10) : null;
  }
  function loadVariantEntry(root) {
    var stockMap = loadJsonScript(root, 'variant-stock') || {};
    var vid = getCurrentVariantId(root);
    var entry = vid && stockMap[vid] ? stockMap[vid] : { stock: 0, tracked: false, continueSelling: false, grams: 0, price: 0 };
    return { id: vid, entry: entry };
  }
  function parseYmdDate(value) {
    var m = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
  }

  var DEFAULT_TABLE = {
    cutoff: '12:00',
    backorder_days: 7,
    transit_by_dept: { default: 1 },
    transit_by_country: { default: 5, FR: null }
  };
  var REMOTE_CACHE = new Map();

  function compute(root) {
    var table = loadJsonScript(root, 'transit-table') || DEFAULT_TABLE;
    if (!table.transit_by_dept && !table.transit_by_country) table = DEFAULT_TABLE;
    var variant = loadVariantEntry(root);
    var vEntry = variant.entry;
    var stock = parseInt(vEntry.stock, 10) || 0;
    var tracked = !!vEntry.tracked;
    var continueSelling = !!vEntry.continueSelling;
    var marketCountry = root.dataset.marketCountry || 'FR';
    var custZip     = root.dataset.customerZip || '';
    var custCountry = root.dataset.customerCountry || '';
    var reqQty = getRequestedQuantity();
    var co = parseCutoff(table.cutoff);
    var now = new Date();
    var cutoff = new Date(now); cutoff.setHours(co.h, co.m, 0, 0);
    var beforeCutoff = now < cutoff;
    var today = isBusinessDay(now);
    if (tracked && !continueSelling && stock <= 0) return { state:'oos', primary:'Produit indisponible', detail:'Réapprovisionnement à venir.' };
    var backorderDays = table.backorder_days || 7;
    var needBackorder = tracked && reqQty != null && reqQty > stock && !continueSelling;
    if (needBackorder) {
      var bShip = (today && beforeCutoff) ? new Date(now) : nextBusinessDay(now);
      var bArrive = addBusinessDays(bShip, backorderDays);
      return { state:'backorder', primary:'Sur commande · livré aux alentours du <strong>' + frDate(bArrive) + '</strong>', detail:'Stock insuffisant pour livraison immédiate.' };
    }
    var shipDate = (today && beforeCutoff) ? new Date(now) : nextBusinessDay(now);
    var dept = parseFrDept(custZip, custCountry);
    var effectiveCountry = custCountry || marketCountry || 'FR';
    var transit = lookupTransit(table, dept, effectiveCountry);
    if (transit == null) transit = 2;
    var arrive = addBusinessDays(shipDate, transit);
    var precise = dept != null;
    var state = 'ok'; var availability = 'Disponible';
    if (tracked && stock > 0 && stock < 20) { state = 'low'; availability = 'Stock limité (' + stock + ')'; }
    // Amazon-style: same wording for precise and imprecise. Connectez-vous hint sits on the cutoff line below.
    var deliveredLabel = 'livré <strong>' + frDateRel(arrive, now) + '</strong>';
    var primary = availability + ' · ' + deliveredLabel;
    var cutoffStr = String(co.h).padStart(2,'0') + 'h' + String(co.m).padStart(2,'0');
    var shipLabel = frDateRel(shipDate, now);
    var detail = '';
    if (today && beforeCutoff) {
      detail = 'Commande validée avant ' + cutoffStr + ' · expédiée ' + shipLabel + '.';
    } else if (today && !beforeCutoff) {
      detail = 'Au-delà de ' + cutoffStr + ' aujourd’hui · prochaine expédition ' + shipLabel + '.';
    } else {
      var shipDayWord = shipDate.toLocaleDateString('fr-FR', { weekday: 'long' });
      detail = 'Commande validée avant ' + cutoffStr + ' ' + shipDayWord + ' · expédiée ' + shipLabel + '.';
    }
    if (!precise && custZip === '') {
      detail += ' <a href="/account" style="color:inherit;text-decoration:underline">Connectez-vous</a> pour une date précise.';
    }
    return { state: state, primary: primary, detail: detail };
  }
  function buildRemoteUrl(root) {
    var apiUrl = root.dataset.promiseApiUrl || '';
    if (!apiUrl) return null;
    var variant = loadVariantEntry(root);
    if (!variant.id) return null;
    var entry = variant.entry;
    var reqQty = getRequestedQuantity();
    var qty = Number.isFinite(reqQty) && reqQty > 0 ? reqQty : 1;
    var stock = parseInt(entry.stock, 10) || 0;
    var tracked = !!entry.tracked;
    var continueSelling = !!entry.continueSelling;
    if (tracked && !continueSelling && stock <= 0) return null;
    if (tracked && !continueSelling && qty > stock) return null;

    var country = root.dataset.customerCountry || root.dataset.marketCountry || 'FR';
    var zip = root.dataset.customerZip || '';
    var url;
    try { url = new URL(apiUrl, window.location.origin); } catch (e) { return null; }
    url.searchParams.set('variantId', variant.id);
    url.searchParams.set('quantity', String(qty));
    url.searchParams.set('grams', String(parseInt(entry.grams, 10) || 0));
    url.searchParams.set('price', String(parseInt(entry.price, 10) || 0));
    url.searchParams.set('country', country);
    url.searchParams.set('zip', zip);
    url.searchParams.set('currency', root.dataset.shopCurrency || 'EUR');
    return url;
  }
  function renderRemotePromise(root, promise) {
    var arrive = parseYmdDate(promise && promise.date);
    if (!arrive) return;

    var variant = loadVariantEntry(root);
    var stock = parseInt(variant.entry.stock, 10) || 0;
    var tracked = !!variant.entry.tracked;
    var state = 'ok';
    var availability = 'Disponible';
    if (tracked && stock > 0 && stock < 20) { state = 'low'; availability = 'Stock limité (' + stock + ')'; }

    var label = promise.service === 'pallet' ? 'livraison sur palette' : 'livré';
    var primary = availability + ' · ' + label + ' <strong>' + frDateRel(arrive, new Date()) + '</strong>';
    root.setAttribute('data-state', state);
    var p = root.querySelector('[data-role="primary-text"]');
    if (p) p.innerHTML = primary;
  }
  function pendingRemotePrimary(localPrimary) {
    var availability = String(localPrimary || '').split(' · ')[0] || 'Disponible';
    return availability + ' · date de livraison en cours…';
  }
  function applyResult(root, result) {
    root.setAttribute('data-state', result.state);
    var p = root.querySelector('[data-role="primary-text"]');
    var d = root.querySelector('[data-role="detail"]');
    if (p) p.innerHTML = result.primary;
    if (d) d.innerHTML = result.detail;
  }
  function scheduleRemotePromise(root, token, url, fallback) {
    var key = url.toString();

    var cached = REMOTE_CACHE.get(key);
    if (cached) {
      if (root.__deliveryPromiseToken === token) renderRemotePromise(root, cached);
      return;
    }

    fetch(key, { method: 'GET', credentials: 'omit' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        if (root.__deliveryPromiseToken !== token) return;
        if (!payload || !payload.ok || !payload.date) {
          applyResult(root, fallback);
          return;
        }
        REMOTE_CACHE.set(key, payload);
        renderRemotePromise(root, payload);
      })
      .catch(function () {
        if (root.__deliveryPromiseToken === token) applyResult(root, fallback);
      });
  }
  function render(root) {
    var r = compute(root); if (!r) return;
    var token = (root.__deliveryPromiseToken || 0) + 1;
    root.__deliveryPromiseToken = token;
    var remoteUrl = (r.state === 'ok' || r.state === 'low') ? buildRemoteUrl(root) : null;
    applyResult(root, remoteUrl ? { state: r.state, primary: pendingRemotePrimary(r.primary), detail: r.detail } : r);
    if (remoteUrl) scheduleRemotePromise(root, token, remoteUrl, r);
  }
  function renderAll() { document.querySelectorAll('.delivery-promise').forEach(render); }
  window.__deliveryPromiseRerender = renderAll;

  var lastVariantId = null;
  function pollVariantChange() {
    var vid = null;
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])');
    if (input) vid = input.value;
    if (!vid) { try { vid = new URL(window.location.href).searchParams.get('variant'); } catch (e) {} }
    if (vid && vid !== lastVariantId) { lastVariantId = vid; renderAll(); }
  }
  function attachVariantObservers() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && !form.__deliveryObserverAttached) {
      var mo = new MutationObserver(function () { pollVariantChange(); });
      mo.observe(form, { subtree: true, attributes: true, attributeFilter: ['value'], childList: true });
      form.__deliveryObserverAttached = true;
    }
  }
  document.addEventListener('DOMContentLoaded', function () { renderAll(); attachVariantObservers(); pollVariantChange(); });
  document.addEventListener('shopify:section:load', function () { renderAll(); attachVariantObservers(); pollVariantChange(); });
  document.addEventListener('change', function (e) {
    if (e.target.matches && (e.target.matches('input[name="quantity"]') || e.target.matches('.quantity__input'))) renderAll();
    if (e.target.matches && (e.target.matches('input[name="options"]') || e.target.matches('select[name="options"]') || e.target.matches('input[name^="options"]') || e.target.matches('select[name^="options"]'))) {
      setTimeout(pollVariantChange, 50);
    }
  });
  window.addEventListener('popstate', pollVariantChange);
  var ticks = 0;
  var iv = setInterval(function () { pollVariantChange(); if (++ticks > 10) clearInterval(iv); }, 1000);
  setInterval(renderAll, 5 * 60 * 1000);
})();
